import React from 'react';
import CameraPlayer from './CameraPlayer';
import { gradeDaTela, rotuloCompleto } from '../../helpers/camerasLayout';

// Uma tela do tour: grade de cameras no layout da tela. Nos layouts com
// destaque ("1 grande + 5"), a primeira camera ocupa um bloco de N x N celulas
// no canto superior esquerdo e as outras preenchem o resto em ordem.
export default function Mosaico({
  tela, ativa, gravadoresPorId, mostrarEquipamento, onAbrirCamera,
}) {
  const grade = gradeDaTela(tela.layout, tela.cameras.length);

  return (
    <div
      className={`cameras-mosaico ${ativa ? 'cameras-mosaico--ativa' : ''}`}
      style={{
        gridTemplateColumns: `repeat(${grade.colunas}, minmax(0, 1fr))`,
        gridTemplateRows: `repeat(${grade.linhas}, minmax(0, 1fr))`,
      }}
      aria-hidden={!ativa}
    >
      {tela.cameras.map((camera, i) => (
        <div
          key={camera.id}
          className="cameras-mosaico__celula"
          style={grade.destaque && i === 0
            ? { gridColumn: `span ${grade.destaque}`, gridRow: `span ${grade.destaque}` }
            : undefined}
        >
          <CameraPlayer
            camera={camera}
            rotulo={mostrarEquipamento ? rotuloCompleto(camera, gravadoresPorId) : camera.nome}
            onClick={() => onAbrirCamera(camera)}
          />
        </div>
      ))}
    </div>
  );
}
